import React, {Component} from 'react';
import PropTypes from "prop-types";
import UserSettingsContainer from "./UserSettingsContainer";
import UserPasswordContainer from "./UserPasswordContainer";
import UserValidContainer from "./UserAccountContainer";
import UserAboutContainer from "./UserAboutContainer";

class UserContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        timezones: PropTypes.array.isRequired,
        requestUserData: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.translate = this.props.baseData.translate;

    }

    render() {

        return (
            <div>
                <div className="ma-bo-20">
                    <UserSettingsContainer
                        baseData={this.props.baseData}
                        timezones={this.props.timezones}
                        requestUserData={this.props.requestUserData}
                    />
                </div>

                <div className="ma-bo-20">
                    <UserPasswordContainer
                        baseData={this.props.baseData}
                        requestUserData={this.props.requestUserData}
                    />
                </div>

                <div className="ma-bo-20">
                    <UserValidContainer
                        baseData={this.props.baseData}
                        requestUserData={this.props.requestUserData}
                    />
                </div>

                <div className="ma-bo-20">
                    <UserAboutContainer
                        baseData={this.props.baseData}
                        requestUserData={this.props.requestUserData}
                    />
                </div>

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('home')}>{this.translate('backToHome')}</a>
                </div>
            </div>
        );

    }

}

export default UserContainer;